import React, { useEffect, useContext } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';
import { Module, UserContext } from '../../../../Context/UserContext/UserContext';
import { Organization } from '../../../Administration/Features/Organization';

export const Settings = () => {
  const { setHeader } = useContext(ModuleContext);
  const { hasAccessToModule } = useContext(UserContext);
  const { formatMessage } = useIntl();

  useEffect(() => {
    setHeader(formatMessage({ id: 'settings.header', defaultMessage: 'Settings' }));
  }, [setHeader, formatMessage]);

  return (
    <Routes>
      <Route path="organization/*" element={<LegacyOrganizationRedirect />} />
      <Route path="legal-list/*" element={<Navigate to="/law-portal/settings" replace />} />
      <Route path="other-requirements/*" element={<Navigate to="/law-portal/settings" replace />} />
      <Route path="help" element={<Navigate to="/law-portal/settings" replace />} />
      {hasAccessToModule(Module.Organization) && <Route path="*" element={<Organization suppressHeader />} />}
      <Route path="*" element={<Navigate to="/law-portal/dashboard" replace />} />
    </Routes>
  );
};

const LegacyOrganizationRedirect = () => {
  const location = useLocation();
  const redirectTo = location.pathname.replace('/law-portal/settings/organization', '/law-portal/settings');

  return <Navigate to={`${redirectTo}${location.search}`} replace />;
};